import { SunpointTemplateDefault } from './SunpointTemplateDefault'

export default SunpointTemplateDefault
